import axios from "../util/axios";
import { createSelector } from "reselect";

import compileMarkdown from "../util/compileMarkdown";

const prefix = "materials/features/help";

const FEATURE_FETCH_STARTED = `${prefix}/FEATURE_FETCH_STARTED`;
const FEATURE_FETCH_ENDED = `${prefix}/FEATURE_FETCH_ENDED`;
const FEATURE_FETCH_FAILED = `${prefix}/FEATURE_FETCH_FAILED`;

const INDEX_FETCH_STARTED = `${prefix}/INDEX_FETCH_STARTED`;
const INDEX_FETCH_ENDED = `${prefix}/INDEX_FETCH_ENDED`;
const INDEX_FETCH_FAILED = `${prefix}/INDEX_FETCH_FAILED`;

const SET_LANGUAGE = `${prefix}/SET_LANGUAGE`;

const indexFetchStart = (_i) => ({ type: INDEX_FETCH_STARTED });
const indexFetchEnd = (data) => ({ type: INDEX_FETCH_ENDED, payload: data });
const indexFetchFail = (err) => ({ type: INDEX_FETCH_FAILED, payload: err });

const fetchStart = (id) => ({ type: FEATURE_FETCH_STARTED, payload: id });
const fetchEnd = (data) => ({ type: FEATURE_FETCH_ENDED, payload: data });
const fetchFail = (err) => ({ type: FEATURE_FETCH_FAILED, payload: err });

const setLanguage = (lang) => ({ type: SET_LANGUAGE, payload: lang });

const initialState = {
  isFetching: false,
  isIndexFetching: false,
  index: null,
  data: null,
  error: null,
  lang: null,
};

// reducer
export default function helpReducer(state = initialState, action) {
  switch (action.type) {
    case FEATURE_FETCH_STARTED:
      return {
        ...state,
        isFetching: true,
        error: null,
        data: null,
      };

    case FEATURE_FETCH_ENDED:
      return {
        ...state,
        data: action.payload,
        isFetching: false,
        error: null,
      };

    case FEATURE_FETCH_FAILED:
      return {
        ...state,
        isFetching: false,
        error: action.payload,
      };

    case INDEX_FETCH_STARTED:
      return {
        ...state,
        isIndexFetching: true,
      };

    case INDEX_FETCH_ENDED:
      return {
        ...state,
        index: action.payload,
        isIndexFetching: false,
        error: null,
      };

    case INDEX_FETCH_FAILED:
      return {
        ...state,
        isIndexFetching: false,
        error: action.payload,
      };

    case SET_LANGUAGE: {
      return {
        ...state,
        lang: action.payload,
      };
    }

    default:
      return state;
  }
}

// selectors

const helpSelector = (state) => state.featureHelp;

const isIndexFetching = createSelector(helpSelector, (helpData) => helpData.isIndexFetching);

export const getFeatureHelpIndex = createSelector(helpSelector, (helpData) => helpData.index);

export const getFeatureHelpContent = createSelector(helpSelector, (helpData) => helpData.data);

export const getFeatureHelpLanguage = createSelector(helpSelector, (helpData) => helpData.lang);

export function fetchFeatureHelpContent(file) {
  return (dispatch, getState) => {
    const lang = getFeatureHelpLanguage(getState());

    const fileUrl = `ext/help/${lang}/${file}`;
    const baseUrl = fileUrl.slice(0, fileUrl.lastIndexOf("/") + 1);

    dispatch(fetchStart());
    axios
      .get(fileUrl, { params: { _: Date.now() } })
      .then((res) => res.data)
      .then((content) => compileMarkdown(content, { baseUrl }))
      .then((content) => {
        dispatch(fetchEnd(content));
      })
      .catch((err) => {
        dispatch(fetchFail(err));
      });
  };
}

export function fetchFeatureHelpIndex(lang) {
  return (dispatch, getState) => {
    const state = getState();
    const index = getFeatureHelpIndex(state);
    const isFetching = isIndexFetching(state);

    if (index || isFetching) {
      return;
    }

    dispatch(setLanguage(lang));
    dispatch(indexFetchStart());

    axios
      .get(`ext/help/${lang}/index.json`, { params: { _: Date.now() } })
      .then((res) => res.data)
      .then((data) => {
        dispatch(indexFetchEnd(data));
      })
      .catch((err) => {
        dispatch(indexFetchFail(err));
      });
  };
}
